module.exports = __webpack_public_path__ + "media/entities/1204-4f6a00ba.png";